import { useEffect, useRef } from 'react';
import { useTelemetry } from '../use-telemetry';
import { PACKAGE_VERSION } from '../../environment';
export var COMPONENT_METADATA_KEY = '__awsuiMetadata__';
export default function useBaseComponent(componentName) {
    var elementRef = useRef(null);
    useTelemetry(componentName);
    useComponentMetadata(componentName, elementRef);
    return {
        __internalRootRef: elementRef
    };
}
function useComponentMetadata(componentName, elementRef) {
    useEffect(function () {
        if (elementRef.current && !Object.prototype.hasOwnProperty.call(elementRef.current, COMPONENT_METADATA_KEY)) {
            var node = elementRef.current;
            var metadata = {
                name: componentName,
                version: PACKAGE_VERSION
            };
            Object.freeze(metadata);
            Object.defineProperty(node, COMPONENT_METADATA_KEY, {
                value: metadata,
                writable: false
            });
        }
    }, [elementRef.current]);
}
